const MARKET_CHANGE_TIME_ZONE = "America/Detroit";

function formatDateKey(date: Date) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: MARKET_CHANGE_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function parseDate(value: string | null | undefined) {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function parseResolvedMarketChange(value: string | null | undefined) {
  if (value == null || value === "") {
    return {
      hasResolvedChange: false,
      value: null,
    };
  }

  const parsed = Number(value);
  return Number.isFinite(parsed)
    ? {
        hasResolvedChange: true,
        value: parsed,
      }
    : {
        hasResolvedChange: false,
        value: null,
      };
}

export function hasFreshIntradayMarketChange(
  asOf: string | null | undefined,
  referenceDate = new Date()
) {
  const parsed = parseDate(asOf);
  if (!parsed) {
    return false;
  }

  return formatDateKey(parsed) === formatDateKey(referenceDate);
}

export function formatMarketChangeAsOf(
  asOf: string | null | undefined,
  options?: { includeTimeWhenFresh?: boolean; includeYear?: boolean }
) {
  const parsed = parseDate(asOf);
  if (!parsed) {
    return null;
  }

  const includeTime =
    options?.includeTimeWhenFresh && hasFreshIntradayMarketChange(asOf);
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: MARKET_CHANGE_TIME_ZONE,
    month: "short",
    day: "numeric",
    year: options?.includeYear && !includeTime ? "numeric" : undefined,
    hour: includeTime ? "numeric" : undefined,
    minute: includeTime ? "2-digit" : undefined,
    timeZoneName: includeTime ? "short" : undefined,
  });

  return formatter.format(parsed);
}

export function getMarketChangeLabel(asOf: string | null | undefined) {
  if (!parseDate(asOf)) {
    return "PRICE CHANGE";
  }

  return "LATEST MARKET DAY";
}
